import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import Layout from '../components/Layout'

export default ({components, ...props}) => <MDXTag name="wrapper" Layout={(props) => <Layout {...props}/>} layoutProps={props} components={components}>

<MDXTag name="h1" components={components} props={{"id":"showcase"}}><MDXTag name="a" components={components} parentName="h1" props={{"ariaHidden":"true","href":"#showcase"}}><MDXTag name="span" components={components} parentName="a" props={{"className":"icon icon-link"}}></MDXTag></MDXTag>{`Showcase`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}></MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}></MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="a" components={components} parentName="td" props={{"href":"https://github.com/plouc/wiremock-ui"}}>{`wiremock-ui`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}>{`An unofficial UI for WireMock`}</MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="a" components={components} parentName="td" props={{"href":"https://github.com/plouc/cucurbit"}}>{`cucurbit`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}>{`Run cucumber-js tests from your browser`}</MDXTag>
</MDXTag>
</MDXTag>
</MDXTag></MDXTag>

export const _frontmatter = {};

  